module.exports = __webpack_public_path__ + "img/66.61818e4d.webp";